import { post } from './http'

const baseUrl = '/api/meas/admin/teach/student'

// 获取学员列表
export const getStudentList = data => post(`${baseUrl}/getStudentList`, data)

// 获取学员详情
export const getStudentDetails = data => post(`${baseUrl}/getStudentDetails`, data)

// 保存学员信息
export const saveStudent = data => post(`${baseUrl}/saveStudent`, data)

// 修改学员状态 
export const updateStudentStatus = data => post(`${baseUrl}/updateStudentStatus`, data)

// 获取学员详情顶部信息
export const getStudentInfo = data => post(`${baseUrl}/getStudentInfo`, data)

// 获取学员的班级信息 
export const getStudentClassList = data => post('/api/meas/admin/teach/class/getStudentClassList', data)

// 获取学员课程信息 
export const getStudentCourseList = data => post('/api/meas/admin/teach/course/getStudentCourseList', data)

// 获取学员学情信息 
export const getStudyDetailsByStatus = data => post('/api/meas/admin/teach/study/getStudyDetailsByStatus', data)

// 获取学员详情 作业xx 
export const getCourseExamList = data => post('/api/meas/admin/teach/courseexam/getCourseExamList', data)
